import { APIModel } from "app/state/api";
import { ApiCallModel } from "app/state/api/interfaces";

export const ExplorerLocations: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-stats/{transactionTypeCode}`
  ),
};

export const ExplorerLocationsMap: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/locations-map/{transactionTypeCode}`
  ),
};

export const ExplorerLocationOfTheMonth: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_API}/explorer/location-of-the-month`),
};

export const ExplorerLocationStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/location/stats/{code}/{transactionTypeCode}`
  ),
};

export const ExplorerLocationsList: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/location/list/{transactionTypeCode}`
  ),
};

export const ExplorerLocationMap: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/location/map-locations/{code}`
  ),
};

// Location page

export const ExplorerLocationPageOverviewStats: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/location/detail/{code}/{transactionTypeCode}`
  ),
};

export const ExplorerLocationPageMap: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/location/map-locations/{code}`
  ),
};

export const ExplorerLocationPageSDGs: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sdgs/{transactionTypeCode}`
  ),
};

export const ExplorerLocationPageOrganisationsNetwork: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-network/{transactionTypeCode}`
  ),
};

export const ExplorerLocationPageOrganisationsDonut: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/organisations-donut/{transactionTypeCode}`
  ),
};

export const ExplorerLocationPageBudgetBySector: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/budget-by-sector/{years}`
  ),
};

export const ExplorerLocationPageSectors: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/general/sectors/{transactionTypeCode}/{year}`
  ),
};

export const ExplorerLocationPageActivityTable: ApiCallModel = {
  ...APIModel(
    `${process.env.REACT_APP_API}/explorer/activity/list/{transactionTypeCode}/{page}`
  ),
};
